import React, { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import UploadImagem from './UploadImagem'
import { useCategory } from '../context/CategoryContext'

const slugify = (s) => String(s || '')
  .normalize('NFD')
  .replace(/[\u0300-\u036f]/g, '')
  .toLowerCase()
  .replace(/[^a-z0-9]+/g, '-')
  .replace(/(^-|-$)/g, '')

export default function NovoProduto() {
  const { categories } = useCategory()
  const navigate = useNavigate()

  const [nome, setNome] = useState('')
  const [descricao, setDescricao] = useState('')
  const [preco, setPreco] = useState('')
  const [unidade, setUnidade] = useState('caixa')
  const [stock, setStock] = useState('')
  const [categoriaId, setCategoriaId] = useState('')
  const [dataColheita, setDataColheita] = useState('')
  const [certificado, setCertificado] = useState(false)
  const [disponivel, setDisponivel] = useState(true)
  const [destaque, setDestaque] = useState(false)
  const [imagem, setImagem] = useState(null)
  const [saving, setSaving] = useState(false)

  const user = (() => {
    try {
      const raw = localStorage.getItem('user')
      return raw ? JSON.parse(raw) : null
    } catch {
      return null
    }
  })()

  const handleSalvar = async () => {
    if (!nome || !preco || !categoriaId) {
      alert('Preencha nome, preço e categoria.')
      return
    }
    const token = localStorage.getItem('authToken')
    if (!token) {
      alert('Precisa iniciar sessão para cadastrar.')
      return
    }
    const payload = {
      nome,
      slug: slugify(nome),
      descricao,
      preco: Number(preco),
      unidade,
      stock: stock ? Number(stock) : null,
      imagem,
      disponivel,
      destaque,
      categoria_id: Number(categoriaId),
      produtor_id: user?.id || null,
      data_colheita: dataColheita || null,
      certificado_biologico: certificado ? 1 : 0,
    }
    try {
      setSaving(true)
      const res = await fetch('/api/produtos', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify(payload),
      })
      const data = await res.json().catch(() => ({}))
      if (!res.ok || data.success === false) {
        throw new Error(data.message || 'Falha ao salvar produto')
      }
      alert('Produto cadastrado com sucesso!')
      navigate('/categorias')
    } catch (err) {
      console.error(err)
      alert(err.message || 'Erro ao salvar')
    } finally {
      setSaving(false)
    }
  }

  return (
    <div className="container" style={{ maxWidth: 840, padding: 16 }}>
      <h2>Cadastrar Novo Produto</h2>
      <div style={{ display: 'grid', gap: 12, background: '#fff', padding: 16, borderRadius: 12 }}>
        <input placeholder="Nome do produto" value={nome} onChange={(e) => setNome(e.target.value)} />
        <textarea placeholder="Descrição" value={descricao} onChange={(e) => setDescricao(e.target.value)} rows={3} />
        <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 8 }}>
          <input type="number" placeholder="Preço" value={preco} onChange={(e) => setPreco(e.target.value)} />
          <input placeholder="Unidade (ex: caixa, kg)" value={unidade} onChange={(e) => setUnidade(e.target.value)} />
          <input type="number" placeholder="Stock" value={stock} onChange={(e) => setStock(e.target.value)} />
          <select value={categoriaId} onChange={(e) => setCategoriaId(e.target.value)}>
            <option value="">Selecione a categoria</option>
            {(categories || []).map((c) => (
              <option key={c.id} value={c.id}>{c.nome}</option>
            ))}
          </select>
          <input type="date" value={dataColheita} onChange={(e) => setDataColheita(e.target.value)} />
          <label style={{ display: 'flex', alignItems: 'center', gap: 6 }}>
            <input type="checkbox" checked={certificado} onChange={(e) => setCertificado(e.target.checked)} />
            Certificado biológico
          </label>
          <label style={{ display: 'flex', alignItems: 'center', gap: 6 }}>
            <input type="checkbox" checked={disponivel} onChange={(e) => setDisponivel(e.target.checked)} />
            Disponível
          </label>
          <label style={{ display: 'flex', alignItems: 'center', gap: 6 }}>
            <input type="checkbox" checked={destaque} onChange={(e) => setDestaque(e.target.checked)} />
            Destaque
          </label>
        </div>

        <UploadImagem onUpload={(url) => setImagem(url)} />

        <button className="icon-btn" onClick={handleSalvar} disabled={saving}>
          {saving ? 'Salvando...' : 'Salvar Produto'}
        </button>

        {imagem && (
          <div>
            <strong>Pré-visualização:</strong>
            <div style={{ marginTop: 8 }}>
              <img src={imagem} alt="Produto" loading="lazy" decoding="async" style={{ width: 180, borderRadius: 8 }} />
            </div>
          </div>
        )}
      </div>
    </div>
  )
}
